<template>
  <section id="product-list">
  <div class="container">
    <div class="categories desktop">
      <ul class="level-0">
        <li :key="category.label" v-for="category in categories">{{ category.label }}
          <ul class="level-1">
            <li :key="subcategory.label" v-for="subcategory in category.subitems" :class="{'active': group === subcategory.url }">
              <div class="col-label"><a :href="subcategory.url">{{ subcategory.label }}</a></div>
              <div class="col-count">{{ itemsCountInCategory(subcategory) }}</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="product-list">

      <div id="ddd" v-if="ddd">
        <span class="ddd-date">5.12</span><strong class="ddd-heading">Dzień Darmowej Dostawy</strong><span class="ddd-truck"></span>
      </div>

      <div class='seria matched'>
        <h1 class="serie-logo" v-html="products[0]['group_name']"></h1>
        <ul class='products'>
          <li v-bind:key="product_index" v-for="(product,product_index) in products"
              v-bind:class="{
                'matched': product.matched,
                'accessory' : true,
                'kind-u': true
                }">
            <item :product="product"/>

          </li>
        </ul><!-- product -->
      </div><!-- list wrap -->

      <div id='not-found' v-if="matchedItems === 0">
        <h1>{{ t('nothing_found') }}</h1>
      </div>

    </div>
  </div>
  </section>
</template>

<script>
  import Item from './Item.vue'
  import $ from 'jquery'
  import _ from 'lodash'

  export default {
    name: 'accessories-list',
    components: {Item},
    props: {
      group: String
    },

    created: function () {
      this.products = _.filter(window.env.data.accessories, {'group_id': this.group});
      this.gatherColors();
      this.matchedItems = this.products.length;
      // czy mamy daty akcji dzień darmowej dostawy
      if (typeof window.ddd !== "undefined") {
        let now = new Date();
        this.ddd = (now > window.ddd.start && now < window.ddd.end );
      }
    },

    mounted: function () {
      $('.selectioner').on('click', function (e) {
        $(this).toggleClass('active')
      })
    },

    data () {
      return {
        ddd: false,
        filters: {
          colors: []
        },
        categories: env.data.menu.accessories.subitems,
        matchedItems: 0,
        series: [], // tu zbierzemy wszystkie kategorie akcesoriów
        colors: {}, // a tu unikalne kolory
        products: {}
      }
    }, // data

    methods: {
      itemsCountInCategory(category) {
        let internal_name = category.class;
        let category_size = _.countBy(env.data.accessories, { group_internal_name: internal_name} );
        return category_size.true;
      },
      showFreeShipmentBanner() {
        let date_start = new Date("5/30/2019").getTime();
        let date_end = new Date("6/09/2019").getTime();
        let now = Date.now();
        return ((now <= date_end && now >= date_start))
        },
      /**
       * Dodawanie filtra do listy
       */
      addFilter: function (kind, filter) {
        if (this.filters[kind].indexOf(filter) === -1) {
          this.filters[kind].push(filter)
        } else {
          this.removeFilter(kind, filter)
        }
        this.applyFilters()
      },

      /**
       * Usuwanie filtra z listy
       */
      removeFilter: function (kind, filter) {
        var index = this.filters[kind].indexOf(filter)
        if (index !== -1) {
          this.filters[kind].splice(index, 1)
        }
        this.applyFilters()
      },

      /**
       * Tłumaczenie stringów z tablicy przekazanej z serwera
       */
      t: function (txt) {
        if (_.has(translations, txt)) {
          return translations[txt]
        }
        return txt
      }, // t

      /**
       * Pobieranie unikalnych kolorów
       */
      gatherColors: function () {
        let that = this
        _.forEach(that.products, product => {
          _.forEach(product.colors, (color, index) => {
            if (typeof (that.colors[index]) !== 'object') {
              that.colors[index] = {
                color_base: index,
                color_name: color.main_color,
                main_color_hex: color.main_color_hex,
                icon: 'background-color: #' + color.main_color_hex
              }
            }
          })
        })
      }, // gatherColors

      // szukamy pustych serii do ukrycia
      serieHasActiveItems: function (el) {
        var matched = false
        _.forEach(this.products[el], function (item) {
          if (item.matched) {
            matched = true
          }
        })
        return matched
      }, // serieHasActiveItems

      /**
       * Obsługa filtrów
       */
      applyFilters: function () {
        this.matchedItems = 0

        _.forEach(this.products, product => {
          let matched = true

          if (this.filters.colors.length > 0) {
            let found = false
            for (let i = 0; i < this.filters.colors.length; i++) {
              if (_.has(product.colors, this.filters.colors[i])) {
                found = true
              }
            }
            matched = matched && found
            if (found) {
              this.setSelectedColor(product, this.filters.colors[0])
            }
          }
          product.matched = matched
          if (matched) this.matchedItems++
        })
      }, // applyFilters

      setSelectedColor: function (product, color) {
        let i = 0
        _.forEach(product.colors, (c, k) => {
          if (k === color) product.col_sel = i
          i++
        })
      }
    } // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/AccessoriesList.vue